"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function Icon(props) {
    return jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, Object.assign({}, props), void 0);
}
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map